module.exports = __webpack_public_path__ + "media/bootstrap-icons/journal-code-8e2602e5.svg";